import angular from 'angular';
import constants from 'app/constants';
import {
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './save-recommendation-confirm-dialog.controller';
import template from './save-recommendation-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, auditId, statuses, businessRisks, technicalRisks, priorities, users, recommendation
  }) {
    return {
      controller,
      controllerAs: 'saveRecommendationConfirmDialogVM',
      locals: {
        customerId,
        auditId,
        statuses,
        businessRisks,
        technicalRisks,
        priorities,
        users,
        recommendation
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.saveRecommendationConfirmDialog', [
  alerts,
  amSharedModelService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('saveRecommendationConfirmDialog', dialogService)
  .name;
